export enum ETokenBudgetScope {
  ORGANIZATION = "organization",
  PROJECT = "project",
  PERSONAL = "personal",
  USER = "user",
}

export enum ETokenBudgetUsageKind {
  TOTAL = "total",
  AGENT = "agent",
}

// NOTE: NSAI-5612 — what a cap counts. Tokens and dollars are separate, equally
// first-class denominations: an organization may run either or both, and each
// cap binds on its own. Mirrors ETokenBudgetUnit on the server.
export enum ETokenBudgetUnit {
  TOKENS = "tokens",
  USD = "usd",
}

// NOTE: NSAI-5612 — why a request was refused. BUDGET_EXHAUSTED waits for the
// period to roll; UNPRICED_MODEL needs an administrator to price the model,
// because usage on it cannot be charged against a dollar cap at all.
export enum ETokenBudgetBlockReason {
  BUDGET_EXHAUSTED = "budget_exhausted",
  UNPRICED_MODEL = "unpriced_model",
}

export interface ITokenBudgetErrorMetadata {
  scope: ETokenBudgetScope;
  usageKind: ETokenBudgetUsageKind;
  resetAt: string;
  // NOTE: Absent on refusals emitted before NSAI-5612 shipped; read as tokens
  // and budget-exhausted respectively.
  unit?: ETokenBudgetUnit;
  reason?: ETokenBudgetBlockReason;
}

export interface IFormatUsageLimitAmountProps {
  amount: number;
  unit: ETokenBudgetUnit;
}
